import React, { createContext, useContext, useMemo, useState } from "react";

// NOTE: The Spring backend (experience-backend) only exposes a bare-bones
// /cause endpoint (id/userId/feelingId/name) with no translations, mood,
// or archived flag, so it cannot back the old Firestore-era CauseType model
// yet. This context is a local, in-memory store so every consumer that used
// to read/write it through Firestore keeps working; nothing here is
// persisted server-side. See components/CauseInput.tsx for the one place
// that does talk to the real backend (POST /cause) when creating a cause.
/** @type {any} */
const defaultCauseContextValue = {
  causeTypes: [],
  setCauseTypes: (..._args) => {},
  activeCauseTypes: [],
  setActiveCauseTypes: (..._args) => {},
  defaultCauseTypes: [],
  setDefaultCauseTypes: (..._args) => {},
  causes: [],
  setCauses: (..._args) => {},
  causeTypesTranslations: {},
  setCauseTypesTranslations: (..._args) => {},
  clearCache: (..._args) => {},
};

const CauseContext = createContext(defaultCauseContextValue);

export const CauseProvider = ({ children }) => {
  const [causeTypes, setCauseTypes] = useState([]);
  const [activeCauseTypes, setActiveCauseTypes] = useState([]);
  const [defaultCauseTypes, setDefaultCauseTypes] = useState([]);
  const [causes, setCauses] = useState([]);
  const [causeTypesTranslations, setCauseTypesTranslations] = useState({});


  const value = useMemo(
    () => ({
      causeTypes,
      setCauseTypes,
      activeCauseTypes,
      setActiveCauseTypes,
      defaultCauseTypes,
      setDefaultCauseTypes,
      causes,
      setCauses,
      causeTypesTranslations,
      setCauseTypesTranslations,
    }),
    [causeTypes, activeCauseTypes, defaultCauseTypes, causes, causeTypesTranslations]
  );

  return <CauseContext.Provider value={value}>{children}</CauseContext.Provider>;
};

export const useCause = () => useContext(CauseContext);
